import { CourseInboxResponse, CourseInboxId, CourseInboxReplyResponse } from '@business/entities/course_inbox';
import { Endpoint } from '@business/api/endpoint';
import { CommonService } from '@business/services';
import { SendMessageFormData } from '@modules/CourseInboxPage/CourseInboxReplyPage/SendMessage';

// Client-scoped course inbox endpoints. The backend hard-scopes every call to the
// authenticated student (enroller_id = Auth::id()), so a client can only ever access
// their own conversation.

export function fetchClientInbox(id: CourseInboxId) {
  return Endpoint.get<CourseInboxResponse>(`@gc/client-inbox/inbox/${id}`);
}

// Resolves the student's own inbox for an essay block; returns null when none exists yet.
export function fetchClientInboxByBlock(blockId: string) {
  return Endpoint.get<CourseInboxResponse | null>(`@gc/client-inbox/by-block/${blockId}`);
}

export function fetchClientInboxReplies(id: CourseInboxId) {
  return Endpoint.get<CourseInboxReplyResponse[]>(`@gc/client-inbox/replies/${id}`);
}

export function createClientInboxReply(data: SendMessageFormData) {
  const formData = CommonService.toFormData(data);

  return Endpoint.post<CourseInboxReplyResponse>(`@gc/client-inbox/reply/${data.inboxId}`, { formData, hasFiles: true });
}
